// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group {
  padding: 8px 8px 8px 8px;
  margin-top: 8px;
  border-color: rgb(195, 195, 195);
  border-radius: 6px;
  border-style: solid;
  border-width: 1px;

  h2 {
    font-size: 24px;
    font-weight: 700;
    display: inline-block;
    padding: 0 0 0 16px;
    color: rgb(53, 48, 48);
  }
}

.groups {
  border-width: 0;
  border-color: rgb(195, 195, 195);
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/group/group.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;;EAEjB;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB","sourcesContent":[".group {\n  padding: 8px 8px 8px 8px;\n  margin-top: 8px;\n  border-color: rgb(195, 195, 195);\n  border-radius: 6px;\n  border-style: solid;\n  border-width: 1px;\n\n  h2 {\n    font-size: 24px;\n    font-weight: 700;\n    display: inline-block;\n    padding: 0 0 0 16px;\n    color: rgb(53, 48, 48);\n  }\n}\n\n.groups {\n  border-width: 0;\n  border-color: rgb(195, 195, 195);\n  margin-top: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
